module.exports = __webpack_public_path__ + "img/android_1.ea4ad0ee.jpg";